export enum CertificationDirection {
    Cybersecurity = 1,
    Onboarding = 2,
    Sales = 3,
    Technical = 4,
}
